export default __webpack_public_path__ + "static/media/indoor-6.82fef67f.png";